'use client';

import { LogoutIcon } from '@repo/icons';
import { TabItem } from '@repo/ui/tab-item';
import { toaster } from '@repo/ui/toast';
import { cn } from '@repo/utils/cn';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import React, { useTransition } from 'react';
import { useRouter } from '@/i18n/routing';
import { signOut } from '@/server-actions/sign-out';

type SignOutButtonProps = {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
};

const SignOutButton = ({ className, orientation }: SignOutButtonProps) => {
  // const pathname = usePathname();
  const router = useRouter();
  const t = useTranslations('authentication.sign-out');

  const client = useQueryClient();

  const [pending, startTransition] = useTransition();

  const handleLogout = () => {
    startTransition(async () => {
      const response = await signOut();

      if (response?.errors?.length) {
        toaster({
          title: t('error-title'),
          description: response.errors,
          status: 'error',
        });
      } else {
        router.replace('/casino');
      }

      client.clear();
    });
  };

  return (
    <TabItem
      type="submit"
      onClick={handleLogout}
      className={className}
      orientation={orientation}
      disabled={pending}
      loading={pending}
      data-testid="account-menu-sign-out-button"
    >
      <div className="flex w-full space-x-1 rtl:flex-row-reverse">
        <LogoutIcon className="h-5 w-5" />
        <span
          className={cn({
            'w-full cursor-pointer px-1.5 text-left rtl:text-right': orientation !== 'vertical',
          })}
        >
          {t('sign-out-button')}
        </span>
      </div>
    </TabItem>
  );
};

export default SignOutButton;
